import { render } from "./view_dealer.vue?vue&type=template&id=74b6ceac&scoped=true"
import script from "./view_dealer.vue?vue&type=script&lang=js"
export * from "./view_dealer.vue?vue&type=script&lang=js"

import "./view_dealer.vue?vue&type=style&index=0&id=74b6ceac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b6ceac"]])

export default __exports__